pageId = 'reports-questions-show'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  $('#link-change-date').on 'click', tower.changeReportDate
